import { hierarchy, tree } from "d3-hierarchy";
import {
  CollectorOutputReadable,
  DeviceOutput,
  SiteConfigurationOutputReadable,
} from "../../../../services/client";

const buildHierarchy = (
  input: SiteConfigurationOutputReadable,
): CollectorNode => {
  const deviceMap = new Map<string, DeviceOutput[]>();

  for (const device of input.device_list) {
    if (!deviceMap.has(device.collector)) {
      deviceMap.set(device.collector, []);
    }
    deviceMap.get(device.collector)!.push(device);
  }

  function buildCollectorTree(
    collector: CollectorOutputReadable,
  ): CollectorNode {
    const children: CollectorNode[] = (collector.children || []).map(
      buildCollectorTree,
    );
    const devices: DeviceOutput[] = deviceMap.get(collector.name) || [];
    const mappedDevices: DeviceNode[] = devices.map((d) => ({
      asset: d,
      name: d.name,
      type: "device",
    }));

    return {
      name: collector.name,
      asset: collector,
      children: children,
      type: "collector",
      devices: mappedDevices,
    };
  }

  return Object.values(input.collector_list).map(buildCollectorTree)[0];
};

export type CollectorNode = {
  name: string;
  children?: CollectorNode[];
  asset: CollectorOutputReadable | DeviceOutput;
  type: "collector";
  devices: DeviceNode[];
};

export type DeviceNode = {
  name: string;
  children?: CollectorNode[];
  asset: DeviceOutput;
  type: "device";
};

export const getTreeLayout = (
  site_config: SiteConfigurationOutputReadable,
  width = 1000,
  height = 800,
) => {
  const rootData = hierarchy(buildHierarchy(site_config));
  const nbDevices = site_config.device_list.length;
  const nbCollectors = rootData.descendants().length;
  const treeLayout = tree<CollectorNode>().size([
    width + nbDevices * 15 + (nbCollectors - 2) * 1000, // If there are only 2 collectors then we don't want to increase the width since they are rendered aprox. underneath each other.
    height + nbDevices * 2,
  ]);

  const root = treeLayout(rootData);

  return root;
};
